import React from 'react';
import Home from '../components/dashboard';
import { LoginRequired } from 'components/AuthLayout';

const Index = () => {
  return (
    <LoginRequired>
      <Home />
    </LoginRequired>
  );
};

export default Index;
